import { BrandsData, BrandsQueryArgs } from '@curvo/apollo'
import { Select } from 'antd'
import { LabeledValue, SelectProps } from 'antd/lib/select'
import { debounce } from 'lodash'
import React, { useEffect, useState } from 'react'
import { StyledSelect, StyledSelectPropsType } from './common'

const { Option } = Select

export const BrandSelect: React.FunctionComponent<
  SelectProps<LabeledValue> &
    StyledSelectPropsType & {
      search?: string
      manufacturerId?: string
    }
> = ({ search, manufacturerId, ...props }) => {
  const [searchText, setSearchText] = useState(search)
  const [query, setQuery] = useState<BrandsQueryArgs>({
    ...(searchText ? { searchText: searchText } : {}),
    ...(manufacturerId ? { manufacturerId: manufacturerId } : {}),
  })

  useEffect(() => {
    setQuery({
      ...(searchText ? { searchText: searchText } : {}),
      ...(manufacturerId ? { manufacturerId: manufacturerId } : {}),
    })
  }, [manufacturerId, searchText])

  return (
    <BrandsData variables={query} fetchPolicy="network-only">
      {({ data, loading }) => (
        <StyledSelect
          onSearch={text => debounce(setSearchText, 800)(text)}
          loading={loading}
          showSearch
          labelInValue
          filterOption={false}
          showArrow={false}
          defaultActiveFirstOption={false}
          placeholder="Select brand"
          {...props}>
          {data &&
            data.brands &&
            data.brands.edges.map(edge => (
              <Option key={props.fullData ? JSON.stringify(edge.node) : edge.node.id}>{edge.node.name}</Option>
            ))}
        </StyledSelect>
      )}
    </BrandsData>
  )
}
